import { Id } from '@nextforce/api'

const keys = {
  all: ['notifications'],
  summary: () => [...keys.all, 'summary'],
  list: (storeId: Id) => [...keys.all, storeId],
}

export default keys
